<template>
  <div :class="generatorMainSectionClass">
    <div :class="generatorTableSectionClass">

      <div class="product-category-stage-actions" v-if="showAddButton">
        <div
            class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
            @click="openAddCategoryModal()"
        >
          <i class="fas fa-plus-circle"/>
          Dodaj kategorię
        </div>
        <div
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm ms-2"
            @click="openImportAssistant()"
        >
          <i class="fas fa-file-upload"/>
          Importuj drzewo kategorii
        </div>


      </div>


      <div class="windows-like-breadcrumb-card mb-3 shadow-sm">
        <div v-if="currentParentCategory && currentParentCategory.name !== 'Bazowa kategoria'"
             class="d-flex align-items-start justify-content-between w-100 p-4 parent-category-block">
          <div class="me-3">
            <div class="d-flex align-items-center mb-1">
              <i class="fas fa-folder text-primary me-2"></i>
              <h5 class="mb-0">Aktualna kategoria: <span class="text-dark fw-semibold">{{
                  currentParentCategory.name
                }}</span></h5>
            </div>
            <p class="text-muted small mb-2" v-if="currentParentCategory.parentCategoryPath">
              {{ currentParentCategory.parentCategoryPath }}</p>
          </div>
          <div class="text-end flex-shrink-0">
            <button class="btn btn-light btn-sm me-2" @click="goBackToParentCategory">
              <i class="fas fa-arrow-left me-1"></i>
              Kategoria nadrzędna
            </button>
            <button class="btn btn-primary btn-sm" @click="openCurrentCategoryProductsList">
              <i class="fas fa-box-open me-1"></i>
              Produkty
            </button>
          </div>
        </div>


        <div>


          <div class="product-category-data-table">
            <div>
              <SearchBar2
                  :searchOptions="fieldsAvailableForSearch"
                  @searchRequest="searchOnList($event)"
              />

            </div>
            <div class="form-check m-4 mt-2">
              <input class="form-check-input" type="checkbox" id="search-in-subcategories"
                     v-model="searchInSubCategories"/>
              <label class="form-check-label" for="search-in-subcategories">Szukaj tylko w podkategoriach danej
                kategorii</label>
            </div>


            <CommonTable2
                ref="categoriesCommonTable"
                :table="tableData"
                rowIdentifier="guid"
                @onItemAction="runAction($event)"
                @onSort="sort($event)"
                @onMassAction="runMassAction($event)"
                @onCheckItem="checkAction($event)"
                @onSelectRow="selectRow"
                :key="refreshTable"
                :currentPage="currentPage"
                :totalRows="commonModule.getCategoriesTotal"
                :totalPages="commonModule.getCategoriesPagesCount"
                :showPaginationTop="true"
                :showPaginationBottom="true"
                :multiselect="multiselect"
                @onPageChange="currentPage = $event"
                :sortColumn="sortingKey"
                :sortDirection="sortingDirection"
                :showMassActions="showMassActions"
                :showRowActions="showRowActions"
                :initiallyCheckedItemsData="selectedCategoriesData"
                :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                :initiallyVisibleColumns="visibleColumnsFilter"
                :enableRowSelection="enableRowSelection"
                :showCheckboxColumn="showCheckboxColumn"
                :stickyScrollbarBottom="0"
            />
          </div>
          <slot name="bottom"></slot>
        </div>


      </div>
    </div>




    <!-- Modal do dodawania/edycji kategorii -->

      <CategoryFormModal
          :showModal="showCategoryModal"
          @update:showModal="showCategoryModal = $event"
          :title="categoryModalTitle"
          :initialCategoryData="currentCategoryFormData"
          @onSave="saveCategory"
          @onClose="closeCategoryModal"
          :key="currentCategoryFormData"
      />



    <!-- Modal asystenta importu drzew kategorii -->
    <b-modal
        v-model="showCategoryImportAssistant"
        title="Import drzewa kategorii"
        scrollable
        hide-footer
        style="z-index:100011!important;"
        size="xl"
    >
      <CategoryTreeImportAssistant
        v-if="showCategoryImportAssistant"
        title="Asystent importu drzewa kategorii"
      />
    </b-modal>

    <CategoryProductListModal
        v-if="currentParentCategory"
        :showModal="showCurrentCategoryProductsListModal"
        @update:showModal="showCurrentCategoryProductsListModal = $event"
        :categoryGuid="currentParentCategory.guid"
        :showMassActions="false"
        title="Produkty w kategorii"
    />
    <CategoryProductListModal
        v-if="selectedCategory"
        :showModal="showSelectedCategoryProductsListModal"
        @update:showModal="showSelectedCategoryProductsListModal = $event"
        :categoryGuid="selectedCategory.guid"
        :showMassActions="false"
        title="Produkty w kategorii"
    />


  </div>
</template>

<script>
import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import CategoryTreeImportAssistant from "./CategoryTreeImportAssistant.vue";
import CategoryFormModal from "@/views/DrugstoreCommonManager/CategoryFormModal.vue";
import Swal from "sweetalert2";
import CategoryProductListModal from "@/views/DrugstoreCommonManager/CategoryProductListModal.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



import {useLayoutStore} from "@/state/pinia";



export default {
  name: "ProductCategoriesDataList",
  props: {
    multiselect: { type: Boolean, default: true },
    showMassActions: { type: Boolean, default: () => true },
    showRowActions: { type: Boolean, default: () => true },
    showAddButton: { type: Boolean, default: () => true },
    selectedCategoriesData: { type: Array, default: () => [] },
    disableInitiallyCheckedItems: { type: Boolean, default: () => false },
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
    visibleActionsFilter:{ // declare only actions keys You want to see
      type:Array,
      default: ()=>[]
    },

    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },
  },
  emits: ["onSelect","applyItemsInSelectMode","onSelectRow"],
  components: {
    CategoryProductListModal,
    BModal,
    SearchBar2,
    CommonTable2,
    CategoryTreeImportAssistant,
    CategoryFormModal
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "name",
      searchInSubCategories:true,
      refreshTable: true,
      showCategoryModal: false,
      categoryModalTitle: "",
      currentCategoryFormData: {},
      currentParentCategory:null,
      selectedCategory:null,
      showCurrentCategoryProductsListModal: false,
      showSelectedCategoryProductsListModal: false,

      tableMassActions: [
        {
          text: "Usuń",
          icon: "fas fa-trash",
          action: "delete-category",
          class: "btn btn-danger table-actions-button edit-button",
          enabled: true,
          tooltip: "Usuń zaznaczone kategorie",
        }
      ],
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },

      showCategoryImportAssistant: false,
      categoryTypes: {'GRUPA ASORTYMENTOWA': 'ASSORTMENT_GROUP', 'ZAMIENNIK WŁASNY': 'OWN_REPLACEMENT', 'INNY': 'OTHER'},

      fieldsAvailableForSearch: [
        {
          name: "Nazwa kategorii",
          key: "name",
        },
        {
          name: "Opis",
          key: "description",
        }
      ],

      availableHeaders: [
        {
          text: "ID",
          key: "id",
          type: "text",
          sortable: true,
          style: "width: 50px;"
        },
        {
          text: "Nazwa",
          key: "name",
          type: "text",
          sortable: true,
        },
        {
          text: "Ścieżka kategorii",
          key: "parentCategoryPath",
          type: "text",
          sortable: false,
        },
        {
          text: "Typ",
          key: "type",
          type: "text",
          sortable: true,
        },
        {
          text: "Kolejność",
          key: "orderIndex",
          type: "number",
          sortable: true,
        },
        {
          text: "Utworzono",
          key: "createdAt",
          type: "date",
          sortable: true,
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [],
        },
      ]
    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },
    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }
    },
    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },

  },
  methods: {


    resetSelectedCategories(){
      if(this.$refs.categoriesCommonTable && this.$refs.categoriesCommonTable.resetCheckedItems){
        this.$refs.categoriesCommonTable.resetCheckedItems();
      }
    },

    openCurrentCategoryProductsList() {
      this.showCurrentCategoryProductsListModal = true;
    },

    openSelectedCategoryProductsList() {
      this.showSelectedCategoryProductsListModal = true;
    },

    goBackToParentCategory(){
      const categoryPathSplit = this.currentParentCategory.parentCategoryPath.split(">");

      if((categoryPathSplit.length === 1 && categoryPathSplit[0].length === 0) || (categoryPathSplit.length === 1 && "Bazowa kategoria" === categoryPathSplit[0])){
        this.currentParentCategory = null;
        this.refreshCategoriesList();
        return;
      }

      const payload = {
        guid: this.currentParentCategory ? this.currentParentCategory.parentCategoryGuid : null
      };
      console.log("Going back to parent category with payload:")
      console.log(payload)
      this.commonModule.httpGetCategoryByGuid(payload).then((response) => {
        this.currentParentCategory = response.data.payload;
        this.refreshCategoriesList();
      });
    },
    // Metody do implementacji
    openImportAssistant() {
      this.showCategoryImportAssistant = true;
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshCategoriesList();
    },

    sort(sortKey) {
      this.sortingKey = sortKey;
      this.refreshCategoriesList();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },

    openAddCategoryModal() {
      this.currentCategoryFormData = this.currentParentCategory ? { parentCategoryGuid: this.currentParentCategory.guid } : {};
      this.categoryModalTitle = "Dodaj nową kategorię";
      this.showCategoryModal = true;
    },

    closeCategoryModal() {
      this.showCategoryModal = false;
      this.currentCategoryFormData = {};
    },

    saveCategory(categoryData) {
      // Ensure type is backend code; if user-friendly string provided, map it
      if (categoryData && categoryData.type) {
        if (this.categoryTypes[categoryData.type]) {
          categoryData.type = this.categoryTypes[categoryData.type];
        }
      }
      // Validate/cast orderIndex to number with default 0
      let oi = Number(categoryData && categoryData.orderIndex);
      if (!Number.isFinite(oi) || oi < 0) {
        oi = 0;
      }
      categoryData.orderIndex = oi;

      if (categoryData.guid) {
        // Aktualizacja istniejącej kategorii
        this.commonModule.httpUpdateCategory(categoryData).then(() => {
          this.showCategoryModal = false;
          this.refreshCategoriesList();
        });
      } else {
        // Dodawanie nowej kategorii
        this.commonModule.httpAddCategory(categoryData).then(() => {
          this.showCategoryModal = false;
          this.refreshCategoriesList();
        });
      }
    },

    refreshCategoriesList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy kategorii produktów");

      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: null
      };

      const payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
        parentCategoryGuid:this.currentParentCategory ? this.currentParentCategory.guid : null,
        searchInSubCategories: this.searchInSubCategories
      };

      this.refreshTable = false;
      this.commonModule.httpGetCategoriesPaging(payload).then(() => {
        const categoriesData = [];
        const categories = JSON.parse(JSON.stringify(this.commonModule.getCategoriesData));
        // Formatowanie danych kategorii
        for (const category of categories) {
          // Formatowanie daty utworzenia
          category.createdAt = this.formatDatetimeToLocaleFormat(category.createdAt);

          // Mapowanie typu kategorii na przyjazną nazwę
          category.type = this.getCategoryTypeName(category.type);
          if(category.hasChildren){

          if(!category["actions"]) {
            category["actions"] = [];
          }
        console.log("Visible actions: ", this.visibleActionsFilter)
            if(this.visibleActionsFilter.length === 0 || this.visibleActionsFilter.includes('open-subcategories')) {
              category["actions"].push({
                text: "",
                icon: "fas fa-folder-open",
                action: "open-subcategories",
                class: "btn btn-primary btn-sm table-actions-button edit-button",
                enabled: true,
                tooltip: "Otwórz podkategorie",
              })
            }
          }else{
            // show products button instead of open subcategories
            if(!category["actions"]) {
              category["actions"] = [];
            }
            if(this.visibleActionsFilter.length === 0 || this.visibleActionsFilter.includes('show-products-in-category')) {
              category["actions"].push({
                text: "",
                icon: "fas fa-box-open",
                action: "show-products-in-category",
                class: "btn btn-primary btn-sm table-actions-button edit-button",
                enabled: true,
                tooltip: "Pokaż produkty w kategorii",
              })
            }
          }


          if(this.visibleActionsFilter.length === 0 || this.visibleActionsFilter.includes('edit-category')){
            category["actions"].push({
              text: "",
              icon: "fas fa-edit",
              action: "edit-category",
              class: "btn btn-info btn-sm table-actions-button edit-button",
              enabled: true,
              tooltip: "Edytuj kategorię",
            });
          }
          if(this.visibleActionsFilter.length === 0 || this.visibleActionsFilter.includes('delete-category')) {
            category["actions"].push({
              text: "",
              icon: "fas fa-trash",
              action: "delete-category",
              class: "btn btn-danger btn-sm table-actions-button edit-button",
              enabled: true,
              tooltip: "Usuń kategorię",
            });
          }



          categoriesData.push(category);
        }

        // Aktualizacja struktury tabeli
        var categoriesHeaders = []
        for (var j = 0; j < this.availableHeaders.length; j++) {
          categoriesHeaders.push(this.availableHeaders[j]);
        }
        if (this.disableInitiallyCheckedItems) {
          var actionsHeaderIndex = categoriesHeaders.findIndex(header => header.key === "actions");
          if (actionsHeaderIndex !== -1) {
            const applyInSelectModeActionIndex = categoriesHeaders[actionsHeaderIndex].actions.findIndex(action => action.action === "row-apply-in-select-mode");
            if(applyInSelectModeActionIndex === -1){
              categoriesHeaders[actionsHeaderIndex].actions.push({
                text: "Wybierz",
                icon: "",
                action: "row-apply-in-select-mode",
                enabled: true,
                tooltip: "Wybierz kategorię",
                class: "btn btn-info btn-sm table-actions-button edit-button",
              })
            }
          }
        }

        this.tableData["headers"] = categoriesHeaders;
        this.tableData["massActions"] = this.tableMassActions;
        if (this.disableInitiallyCheckedItems) {
          this.tableData["massActions"].push({
            text: "Wybierz zaznaczone",
            icon: "",
            action: "mass-apply-in-select-mode",
            class: "btn btn-info table-actions-button edit-button",
            enabled: true,
            tooltip: "Wybierz zaznaczone kategorie",
          })
        }

        this.tableData["data"] = categoriesData;

        this.refreshTable = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);
      }).catch((error) => {
        console.error('Błąd podczas pobierania kategorii:', error);
        this.lazyloaderModule.setDisplayLazyLoader(false);
      });

    },

    formatDatetimeToLocaleFormat(datetime) {
      if (!datetime) return '';
      return new Date(datetime).toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

// Pomocnicza metoda do tłumaczenia typu kategorii
    getCategoryTypeName(type) {
      const typeMap = {
        'ASSORTMENT_GROUP': 'GRUPA ASORTYMENTOWA',
        'OWN_REPLACEMENT': 'ZAMIENNIK WŁASNY',
        'OTHER': 'INNY'
      };
      return typeMap[type] || type;
    },


    runAction(event) {
      if (event.action.action === "edit-category") {
        this.currentCategoryFormData = []
        this.commonModule.httpGetCategoryByGuid({guid:event.itemData.guid}).then((response) => {
          this.currentCategoryFormData = response.data.payload;
          this.categoryModalTitle = "Edytuj kategorię";

          console.log("Editing category data:");
          console.log(this.currentCategoryFormData);
          this.showCategoryModal = true;
        });
      } else if (event.action.action === "delete-category") {
        this.confirmDeleteCategory(event.itemData);
      } else if (event.action.action === "row-apply-in-select-mode") {
        this.$emit("applyItemsInSelectMode", [event.itemData.guid]);
      } else if (event.action.action === "open-subcategories") {
        this.openSubcategoriesOfCategory(event.itemData);
      }else if(event.action.action === "show-products-in-category"){
        this.selectedCategory = event.itemData;
        this.openSelectedCategoryProductsList();
      }

    },

    openSubcategoriesOfCategory(category){
      this.currentParentCategory = category;
      this.refreshCategoriesList();
    },
    runMassAction(event) {
      if (event.action.action === "delete-category") {
        // event.items contains GUIDs
        this.deleteCategoriesByGuids(event.items);
      } else if (event.action.action === "mass-apply-in-select-mode") {
        this.$emit("applyItemsInSelectMode", event.items);
      }
    },

    checkAction(event) {
      this.$emit("onSelect", event.itemsData);
    },
    selectRow(event) {
      this.$emit("onSelectRow", [event.itemData]);
    },

    deleteCategoriesByGuids(guids) {
      // Confirm deletion
      Swal.fire({
        title: "Usunąć kategorie?",
        text: "Czy na pewno usunąć wybrane kategorie? Operacja jest nieodwracalna!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        customClass: { container: "swal-highest" },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          this.commonModule.httpDeleteCategory({categoryGuids:guids}).then(() => {
            this.refreshCategoriesList();
          });
        }
      });
    },

    confirmDeleteCategory(category) {
      Swal.fire({
        title: "Czy na pewno chcesz usunąć tę kategorię?",
        text: "Tej operacji nie można cofnąć",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Tak, usuń",
        cancelButtonText: "Anuluj",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.isConfirmed) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpDeleteCategory({categoryGuids:[category.guid]}).then(() => {
            this.refreshCategoriesList();
          });
        }
      });
    },
  },
  created() {
    this.refreshCategoriesList();
  }
};




</script>

<style scoped>
.product-category-stage-actions {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.product-category-data-stage {
  margin-top: 20px;
}

.product-category-data-table {
  margin-top: 2px;
}

.parent-category-block {
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.package-orders-generator-site {

}
</style>
